import { Component, Input, ViewChildren, QueryList, OnInit, AfterViewInit } from '@angular/core';

import { AuthService } from '../../../../../core';
import { CurvaAbcVendaFilter } from '../../filter';
import { CurvaAbcVendaPerspectiva, getPerspectivas } from '../curva-abc-venda-perspectiva';
import { CurvaAbcVendaPerspectivaContentComponent } from '../content';

@Component({
    selector: 'sgt-curva-abc-venda-perspectiva-nav',
    templateUrl: './curva-abc-venda-perspectiva-nav.component.html',
    styleUrls: ['./curva-abc-venda-perspectiva-nav.component.less']
})
export class CurvaAbcVendaPerspectivaNavComponent implements OnInit, AfterViewInit {
    isRepresentante: boolean;
    @Input() filter: CurvaAbcVendaFilter;
    @Input() filterStorageKey: string = null;

    perspectivas: CurvaAbcVendaPerspectiva[];
    @ViewChildren('perspectivaContent') private perspectivaContents: QueryList<CurvaAbcVendaPerspectivaContentComponent>;
    private currentPerspectivaContent: CurvaAbcVendaPerspectivaContentComponent;


    constructor(private authService: AuthService) {}

    ngOnInit() {
        this.isRepresentante = this.authService.isRepresentante();
        this.perspectivas = getPerspectivas(this.isRepresentante);
    }

    ngAfterViewInit() {
        this.currentPerspectivaContent = this.perspectivaContents?.first;
    }

    onTabClick(perspectiva: CurvaAbcVendaPerspectiva) {
        this.currentPerspectivaContent = this.perspectivaContents?.find(perspectivaContentFilter => perspectivaContentFilter.perspectiva.id === perspectiva.id);

        // Precisamos dar um resize na janela pq como temos o datatables para ficar na tela inteira, ele está com o bug quando alterna entre as abas
        setTimeout(() => jQuery(window).trigger('resize'), 0);
    }

    search() {
        this.perspectivaContents?.forEach(perspectivaComponent => {
            perspectivaComponent.search();
        });
    }

    getPerspectiva(): CurvaAbcVendaPerspectiva {
        return this.currentPerspectivaContent?.perspectiva;
    }

    getOrderBy(): number {
        return this.currentPerspectivaContent?.getOrderBy();
    }

    getOrderByDir(): string {
        return this.currentPerspectivaContent?.getOrderByDir();
    }
}
